module.exports = __webpack_public_path__ + "static/media/ic-view-16.ef37e151.svg";